import { Outlet } from 'react-router-dom'

import EnterpriseSidebarNav from './enterprise-sidebar-nav'

const EnterpriseSettingsLayout = () => {
  return (
    <div className="size-full overflow-hidden bg-white">
      <div className="flex size-full min-h-0">
        <aside className="h-full w-[340px] shrink-0 overflow-y-auto border-r border-lightBorder px-[35px] pb-8 pt-[56px]">
          <EnterpriseSidebarNav />
        </aside>
        <main className="min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default EnterpriseSettingsLayout
